export type UnidEntitySearchState = {
    searchTrigger: number;
    drawerOpen: boolean;
};

export enum ACTION_TYPES {
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const UnidEntitySearchReducer = (state: UnidEntitySearchState, action: any): UnidEntitySearchState => {
    switch (action.type) {
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawerOpen: true };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawerOpen: false };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
